import { createFileRoute } from '@tanstack/react-router';
import { ImageFeed } from '@/features/mattermost-image-validation/components/ImageFeed';
import { usePermissions } from '@/common/hooks/usePermissions';
import { Permission } from '@/common/enums/permissions.enum';
import { Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/mattermost-image-validation')({
  component: MattermostImageValidationPage,
});

function MattermostImageValidationPage() {
  const { hasPermission } = usePermissions();
  const hasAccess = hasPermission(Permission.MATTERMOST_IMAGE_VALIDATION);

  if (!hasAccess) {
    return <Navigate to="/" />;
  }

  return (
    <div className="container mx-auto py-6 px-4">
      <ImageFeed />
    </div>
  );
}
